import React from 'react';
import YouTubePlayer from 'components/YoutubePlayer';
import styles from './YoutubePlayerWrapper.module.scss';

const YoutubePlayer = ({ url, player }) => {
  // Add origin parameter to YouTube URL for iframe embeds to fix domain restrictions
  const getYouTubeUrl = (youtubeUrl) => {
    if (typeof window === 'undefined' || !youtubeUrl) return youtubeUrl;
    
    try {
      const urlObj = new URL(youtubeUrl);
      // Only add origin if it's a YouTube embed URL and origin is not already present
      if (urlObj.hostname.includes('youtube.com') && !urlObj.searchParams.has('origin')) {
        urlObj.searchParams.set('origin', window.location.origin);
        return urlObj.toString();
      }
    } catch (e) {
      // If URL parsing fails, return original URL
    }
    return youtubeUrl;
  };

  return (
    <div className={styles.videoWrapper}>
      {player && player === 'iFrame' ? (
        <div className={styles.video}>
          <iframe
            src={getYouTubeUrl(url)}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            title="YouTube video player"
            className={styles.iframe}
          ></iframe>
        </div>
      ) : (
        <YouTubePlayer url={url} />
      )}
    </div>
  );
};

export default YoutubePlayer;
